module.exports = __webpack_public_path__ + "media/lifesum-intro-fr-4bdfbc87.mp4";